<template>
    <ion-slides
        :pager="true"
        :options="slideOpts"
        class="c-slider"
        v-if="visibleSlides.length > 0 && !updateSlides"
        ref="slider"
        @ionSlidesDidLoad="slidesDidLoad()"
        :class="{
            '-small':
                currentPage === 'dashboardLoggedIn' ||
                currentPage === 'schadensmeldung',
        }"
    >
        <template v-for="(slide, index) in visibleSlides">
            <ion-slide
                :key="index"
                class="c-slider__element"
                @click="changePage(slide.link)"
                data-swiper-autoplay="5000"
                :class="{
                    '-has-background': slide.backgroundimg,
                }"
                :style="backgroundStyle(slide.backgroundimg)"
            >
                <ion-grid>
                    <template>
                        <ion-row>
                            <ion-col size="12" v-if="'icon' in slide">
                                <ion-icon
                                    :name="slide.icon"
                                    size="large"
                                ></ion-icon>
                            </ion-col>
                            <ion-col size="12">
                                <div
                                    class="c-slider__subheadline"
                                    v-if="'subtitle' in slide"
                                    v-html="slide.subtitle"
                                ></div>
                                <h2
                                    class="c-slider__headline"
                                    v-if="'title' in slide"
                                    v-html="slide.title"
                                ></h2>
                            </ion-col>
                        </ion-row>
                        <ion-row v-if="'description' in slide">
                            <ion-col>
                                <p v-html="slide.description"></p>
                            </ion-col>
                        </ion-row>
                        <ion-row v-if="'img' in slide">
                            <ion-col>
                                <img
                                    v-if="!slide.backgroundimg"
                                    class="c-slider__image"
                                    :src="`${baseurl}/content/dam/klickmal/me1ns/sliderimages/${slide.img}`"
                                />
                            </ion-col>
                        </ion-row>

                        <component
                            v-if="'component' in slide"
                            :is="slide.component"
                            :contractId="slide.contractId"
                            :class="{
                                'c-pie-chart':
                                    slide.component === 'FlexibleLifeChart',
                            }"
                        />
                    </template>
                </ion-grid>
            </ion-slide>
        </template>
    </ion-slides>
    <div v-else-if="$store.state.loading">
        <ion-slides pager="true" class="c-slider">
            <ion-slide class="c-slider__element">
                <ion-grid>
                    <ion-row>
                        <ion-col size="12">
                            <div>
                                <ion-skeleton-text
                                    animated
                                    style="width: 20%;"
                                ></ion-skeleton-text>
                            </div>
                            <h2 class="c-slider__headline">
                                <ion-skeleton-text
                                    animated
                                    style="width: 50%;"
                                ></ion-skeleton-text>
                            </h2>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-skeleton-text
                                animated
                                style="width: 80%;"
                            ></ion-skeleton-text>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-skeleton-text
                                animated
                                style="width: 20%; height: 50%;"
                            ></ion-skeleton-text>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-slide>
        </ion-slides>
    </div>
</template>

<script>
// import * as components from "@/components";
// import VollWertChart from "@/components/VollWertChart";

import FlexibleLifeChart from "@/components/FlexibleLifeChart";
import BautagebuchWidget from "@/components/BautagebuchWidget";
import { BASEURL } from "@/utils/globals";
import { page } from "@/mixins/page";

export default {
    name: "Slider",
    mixins: [page],
    components: {
        // ...components
        FlexibleLifeChart,
        BautagebuchWidget,
        // VollWertChart
    },
    props: {
        currentPage: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            slideOpts: {
                initialSlide: 1,
                speed: 400,
                autoplay: {
                    delay: 15000,
                },
            },
            publicPath: process.env.BASE_URL,
            baseurl: BASEURL,
            updateSlides: false,
        };
    },
    mounted() {
        this.$store.dispatch("slidesConfig/getSlidesConfig");
    },
    computed: {
        slides() {
            let result = [];
            if (this.currentPage in this.$store.state.slidesConfig.all) {
                result = this.$store.state.slidesConfig.all[this.currentPage];
            }

            return result;
        },
        visibleSlides() {
            let result = [];
            if (Array.isArray(this.slides)) {
                for (let slide of this.slides) {
                    if (("show" in slide && slide.show) || !("show" in slide)) {
                        if (
                            slide.motive === undefined ||
                            slide.motive in this.motives
                        ) {
                            let hasFeature = false;
                            if (slide.feature !== undefined) {
                                let contracts = this.$store.state.contracts;
                                for (let key in contracts) {
                                    if (
                                        contracts[key].hasOwnProperty(
                                            "Features"
                                        ) &&
                                        contracts[key].Features.hasOwnProperty(
                                            slide.feature
                                        )
                                    ) {
                                        hasFeature = true;
                                        break;
                                    }
                                }
                            } else {
                                hasFeature = true;
                            }
                            if (hasFeature) {
                                result.push(slide);
                            }
                        }
                    }
                }
            }
            return result;
        },
        motives() {
            return this.$store.getters.motives;
        },
    },
    watch: {
        visibleSlides: {
            handler() {
                // Workaround, because this.$slider.update() and this.$slider.getSwiper() are not functioning
                this.updateSlides = true;
                this.$nextTick(() => {
                    this.updateSlides = false;
                });
            },
            deep: true,
        },
    },
    methods: {
        slidesDidLoad() {
            if (this.$refs.slider !== undefined) {
                this.$refs.slider.startAutoplay();
            }
        },

        backgroundStyle(backgroundpath) {
            if (backgroundpath !== undefined) {
                return {
                    "background-image":
                        "url(" +
                        this.baseurl +
                        "/content/dam/klickmal/me1ns/sliderimages/" +
                        backgroundpath +
                        ")",
                };
            } else {
                return {};
            }
        },
    },
};
</script>

<style lang="scss" scoped>
ion-slides {
    padding-bottom: 35px;
    --bullet-background: var(--ion-color-medium-shade);
    --bullet-background-active: var(--ion-color-medium-shade);
}

ion-slide {
    border-radius: var(--gangl-border-radius);
    background-color: var(--ion-color-medium);
    height: 300px;
    padding: 10px 20px;
    // overflow-y: visible;

    @media only screen and (min-height: 690px) {
        height: 350px;
    }

    // @media only screen and (min-width: $breakpoint-xxl) {
    //     height: 500px;
    // }
}
</style>

<style lang="scss">
.c-slider {
    &.-small {
        padding-bottom: 25px;
        ion-slide {
            height: 200px;
        }
        .swiper-pagination-bullets {
            bottom: 0px;
        }
        .c-slider__headline {
            font-size: 18px;
            // font-weight: bold;
        }
        .c-slider__subheadline {
            font-size: 16px;
        }
        .c-slider__element.-has-background {
            background-size: auto 58%;
        }
    }
    &__element {
        text-align: left;
        overflow: hidden;
        align-items: start;

        background-image: none;
        &.-has-background {
            background-size: auto 60%;
            @media only screen and (min-width: $breakpoint-md) {
                background-size: auto 83%;
            }

            background-position: center bottom;
            background-repeat: no-repeat;
        }
    }
    &__headline {
        margin-top: 0;
        @media only screen and (max-width: $breakpoint-xs) {
            br {
                display: none;
            }
        }
        @media only screen and (min-width: $breakpoint-md) {
            br {
                display: none;
            }
        }
    }
    &__image {
        //   max-width: calc(100% + 40px);
        //   margin-left: -20px;
        //   margin-right: -20px;

        @media only screen and (min-width: $breakpoint-md) {
            height: 400px;
        }
    }
    .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
    }
}

.c-pie-chart {
    .c-flexible-life-chart {
        // border: solid red 1px;
        height: 150px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: var(--gangl-padding-large);
        // background-color: red;

        canvas {
            z-index: 2;
            position: relative;
        }
        &:before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 15%;
            z-index: 1;
            width: 100%;
            height: 70%;
            background: var(--ion-color-light);
        }
    }
}

// .FlexibleLifeChart {
//   // border: solid red 1px;
//   height: 150px;
//   position: absolute;
//   left: 0;
//   bottom: var(--gangl-padding-small);
//   // background-color: red;

//   canvas {
//     z-index: 2;
//     position: relative;
//   }
//   &:before {
//     content: "";
//     display: block;
//     position: absolute;
//     left: 0;
//     top: 15%;
//     z-index: 1;
//     width: 100%;
//     height: 70%;
//     background: var(--ion-color-light);
//   }
// }
</style>
